import React from "react";
import {
  Box,
  Card,
  Typography,
  Divider,
  Stack,
  Container,
} from "@mui/material";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";

const WalletPoints = ({ balance, totalEarned, totalRedeemed }) => {
  return (
    <Container maxWidth="xs" sx={{ mt: 4 }}>
      <Card
        elevation={0}
        sx={{
          p: 3,
          borderRadius: 4,
          textAlign: "center",
          background: "linear-gradient(145deg, #ffffff 0%, #f5f7fa 100%)",
          border: "1px solid #e0e0e0",
        }}
      >
        {/* Seção Saldo Principal */}
        <Box sx={{ mb: 4 }}>
          <Typography
            variant="overline"
            color="text.secondary"
            fontWeight="700"
            letterSpacing={1}
          >
            Saldo Atual
          </Typography>
          <Typography
            variant="h1"
            component="div"
            sx={{
              fontWeight: 800,
              color: "#333",
              my: 1,
              fontSize: { xs: "3rem", sm: "3.5rem" },
            }}
          >
            {balance.toLocaleString("pt-BR")}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Pontos acumulados
          </Typography>
        </Box>

        <Divider sx={{ mb: 4 }}>
          <Box
            sx={{
              bgcolor: "primary.main",
              color: "white",
              borderRadius: "50%",
              p: 0.5,
              display: "flex",
            }}
          >
            <ArrowUpwardIcon fontSize="small" />
          </Box>
        </Divider>

        {/* Detalhamento: Ganhos e Resgatados */}
        <Stack direction="row" spacing={2} justifyContent="space-between">
          {/* Pontos Ganhos */}
          <Box sx={{ flex: 1 }}>
            <Stack
              direction="row"
              alignItems="center"
              spacing={0.5}
              justifyContent="center"
              sx={{ mb: 0.5 }}
            >
              <AddCircleOutlineIcon
                sx={{ fontSize: 16, color: "success.main" }}
              />
              <Typography
                variant="caption"
                fontWeight="bold"
                color="text.secondary"
              >
                GANHOS
              </Typography>
            </Stack>
            <Typography
              variant="h6"
              sx={{ color: "success.main", fontWeight: 700 }}
            >
              {totalEarned.toLocaleString("pt-BR")}
            </Typography>
          </Box>

          <Divider orientation="vertical" flexItem />

          {/* Pontos Resgatados */}
          <Box sx={{ flex: 1 }}>
            <Stack
              direction="row"
              alignItems="center"
              spacing={0.5}
              justifyContent="center"
              sx={{ mb: 0.5 }}
            >
              <RemoveCircleOutlineIcon
                sx={{ fontSize: 16, color: "error.main" }}
              />
              <Typography
                variant="caption"
                fontWeight="bold"
                color="text.secondary"
              >
                RESGATADOS
              </Typography>
            </Stack>
            <Typography
              variant="h6"
              sx={{ color: "error.main", fontWeight: 700 }}
            >
              {totalRedeemed.toLocaleString("pt-BR")}
            </Typography>
          </Box>
        </Stack>
      </Card>
    </Container>
  );
};

export default WalletPoints;
